function bindVariants(root = document) {
  root.querySelectorAll('[data-ev-variant]').forEach(select => {
    if (select.dataset.evBound) return;
    select.dataset.evBound = 'true';
    const update = () => {
      const option = select.selectedOptions[0];
      const pack = select.closest('[data-ev-pack]');
      if (!option || !pack) return;
      const button = pack.querySelector('[data-ev-add]');
      pack.querySelector('[data-ev-price]').textContent = option.dataset.price;
      pack.querySelector('[data-ev-unit]').textContent = option.dataset.unit;
      button.disabled = option.dataset.available !== 'true';
      button.querySelector('[data-ev-add-text]').textContent = button.disabled ? button.dataset.soldLabel : button.dataset.addLabel;
    };
    select.addEventListener('change', update);
    update();
  });
}
let stopSticky = () => {};
function bindSticky() {
  stopSticky();
  const sticky = document.querySelector('[data-ev-sticky]');
  const hero = document.querySelector('[data-ev-hero]');
  const shop = document.querySelector('[data-ev-shop]');
  const footer = document.querySelector('footer');
  if (!sticky || !hero || !shop || !('IntersectionObserver' in window)) return;
  const update = () => {
    const h = hero.getBoundingClientRect();
    const s = shop.getBoundingClientRect();
    const f = footer?.getBoundingClientRect();
    const shopVisible = s.top < innerHeight && s.bottom > 0;
    const footerVisible = f && f.top < innerHeight && f.bottom > 0;
    const visible = h.bottom <= 0 && !shopVisible && !footerVisible;
    sticky.hidden = !visible;
    sticky.dataset.visible = String(visible);
  };
  const observer = new IntersectionObserver(update, {threshold: 0});
  [hero, shop, footer].filter(Boolean).forEach(el => observer.observe(el));
  stopSticky = () => { observer.disconnect(); sticky.hidden = true; };
  update();
}
const galleryCleanups = new Map();
function bindGallery(root = document) {
  root.querySelectorAll('[data-ev-gallery]').forEach(gallery => {
    if (galleryCleanups.has(gallery)) return;
    const controller = new AbortController();
    const signal = controller.signal;
    const rail = gallery.querySelector('[data-ev-gallery-rail]');
    const panels = [...gallery.querySelectorAll('[data-ev-gallery-panel]')];
    const links = [...gallery.querySelectorAll('[data-ev-gallery-link]')];
    const dialog = gallery.querySelector('[data-ev-image-dialog]');
    const image = dialog?.querySelector('[data-ev-zoom-image]');
    const canvas = dialog?.querySelector('[data-ev-image-toggle]');
    const viewport = dialog?.querySelector('[data-ev-image-viewport]');
    const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
    let current = 0;
    let queued = false;
    let opener;
    const mark = index => {
      current = Math.max(0, Math.min(index, panels.length - 1));
      links.forEach((link, position) => {
        if (position === current) link.setAttribute('aria-current', 'true');
        else link.removeAttribute('aria-current');
      });
    };
    const navigate = (index, smooth = true) => {
      mark(index);
      rail.scrollTo({left: panels[current].offsetLeft - panels[0].offsetLeft, behavior: !reduced && smooth ? 'smooth' : 'instant'});
    };
    links.forEach((link, index) => link.addEventListener('click', event => {
      event.preventDefault();
      navigate(index);
    }, {signal}));
    gallery.addEventListener('keydown', event => {
      if (dialog?.open || event.altKey || event.ctrlKey || event.metaKey) return;
      const keys = {ArrowLeft: current - 1, ArrowRight: current + 1, Home: 0, End: panels.length - 1};
      if (!(event.key in keys)) return;
      event.preventDefault();
      navigate(keys[event.key], false);
    }, {signal});
    rail.addEventListener('scroll', () => {
      if (queued) return;
      queued = true;
      requestAnimationFrame(() => {
        const left = rail.scrollLeft;
        let nearest = 0;
        panels.forEach((panel, index) => {
          if (Math.abs(panel.offsetLeft - panels[0].offsetLeft - left) < Math.abs(panels[nearest].offsetLeft - panels[0].offsetLeft - left)) nearest = index;
        });
        mark(nearest);
        queued = false;
      });
    }, {passive: true, signal});
    const resize = typeof ResizeObserver === 'function' ? new ResizeObserver(() => navigate(current, false)) : null;
    resize?.observe(rail);
    if (dialog && typeof dialog.showModal === 'function') {
      image.addEventListener('load', () => {
        image.width = image.naturalWidth;
        image.height = image.naturalHeight;
      }, {signal});
      const resetZoom = () => {
        canvas.classList.remove('is-zoomed');
        canvas.setAttribute('aria-pressed', 'false');
        viewport.scrollTo({top: 0, left: 0, behavior: 'instant'});
      };
      gallery.querySelectorAll('[data-ev-image-open]').forEach(link => link.addEventListener('click', event => {
        event.preventDefault();
        opener = link;
        image.src = link.href;
        image.alt = link.dataset.imageTitle;
        dialog.querySelector('[data-ev-image-title]').textContent = link.dataset.imageTitle;
        resetZoom();
        if (!dialog.open) dialog.showModal();
        document.documentElement.classList.add('ev-dialog-open');
      }, {signal}));
      dialog.querySelector('[data-ev-image-close]').addEventListener('click', () => dialog.close(), {signal});
      dialog.addEventListener('click', event => {
        if (event.target !== dialog) return;
        const rect = dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
      }, {signal});
      dialog.addEventListener('close', () => {
        document.documentElement.classList.remove('ev-dialog-open');
        resetZoom();
        if (opener?.isConnected) opener.focus({preventScroll: true});
      }, {signal});
      canvas.addEventListener('click', () => {
        const zoomed = canvas.classList.toggle('is-zoomed');
        canvas.setAttribute('aria-pressed', String(zoomed));
        requestAnimationFrame(() => viewport.scrollTo({left: zoomed ? (viewport.scrollWidth - viewport.clientWidth) / 2 : 0, top: zoomed ? (viewport.scrollHeight - viewport.clientHeight) / 2 : 0, behavior: 'instant'}));
      }, {signal});
    }
    galleryCleanups.set(gallery, () => {
      if (dialog?.open) dialog.close();
      controller.abort();
      resize?.disconnect();
      document.documentElement.classList.remove('ev-dialog-open');
    });
  });
}
function init(root = document) { bindVariants(root); bindGallery(root); bindSticky(); }
init();
document.addEventListener('shopify:section:load', event => init(event.target));
document.addEventListener('shopify:section:unload', event => {
  galleryCleanups.forEach((cleanup, gallery) => {
    if (event.target.contains(gallery)) { cleanup(); galleryCleanups.delete(gallery); }
  });
  requestAnimationFrame(bindSticky);
});
document.addEventListener('shopify:section:reorder', bindSticky);
